import { render, staticRenderFns } from "./checkbox-input.vue?vue&type=template&id=5f39a1c3&"
import script from "./checkbox-input.vue?vue&type=script&lang=js&"
export * from "./checkbox-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports